import { Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { GlobalAlertComponent } from "./common/components/global-alert/global-alert.component";
import { SystemBannerComponent } from "./common/components/system-banner/system-banner.component";
import { AgentChatSheetComponent } from "./agent-chat/agent-chat-sheet.component";
import { WalkthroughSpotlightComponent } from "./walkthroughs/walkthrough-spotlight.component";
import { SystemMessagesService } from "./common/services/system-messages.service";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    imports: [RouterOutlet, GlobalAlertComponent, SystemBannerComponent, AgentChatSheetComponent, WalkthroughSpotlightComponent]
})
export class AppComponent {
  constructor() {
    // Announcement polling (deploy banners etc.) lives for the app's lifetime.
    inject(SystemMessagesService).start();
  }
}
